module.exports = __webpack_public_path__ + "static/img/pengu.0f68fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/coach/pengu.png
// module id = 0R18
// module chunks = 35